export default {
  chartOptionsForBarChart: {
    backgroundColor: 'transparent',
    chartArea: {
      left: 40,
      width: '100%'
    },
    tooltip: {
      isHtml: true,
      textStyle: {
        color: '#fff',
        fontSize: 12
      },
      ignoreBounds: true
    },
    areaOpacity: 1,
    fontName: 'Muli',
    fontSize: 14,
    pointSize: 12,
    vAxis: {
      viewWindow: { min: 0 },
      baselineColor: 'transparent',
      baseline: 0,
      gridlines: {
        color: 'transparent'
      },
      textStyle: {
        color: '#1B2342'
      },
      minValue: 1
    },
    hAxis: {
      textStyle: {
        color: '#1B2342'
      }
    },
    series: [{ color: '#58e2c2' }, { color: '#1B2342' }, { color: '#7440FB' }],
    legend: 'none',
    bar: {
      groupWidth: '50%'
    }
  },
  chartOptionsForAreaGraph: {
    backgroundColor: 'transparent',
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out'
    },
    chartArea: {
      left: 40,
      right: 20,
      width: '90%',
      height: '250px'
    },
    tooltip: {
      isHtml: true,
      textStyle: {
        color: '#fff',
        fontSize: 12
      },
      ignoreBounds: true
    },
    areaOpacity: 0.3,
    fontName: 'Muli',
    fontSize: 14,
    vAxis: {
      //      baseline: 0,
      baselineColor: 'transparent',
      gridlines: {
        color: 'transparent'
      },
      textStyle: {
        color: '#1B2342'
      },
      // viewWindow: { min: 0 },
      format: 0,
      minValue: 1
    },
    hAxis: {
      textStyle: {
        color: '#1B2342'
      }
    },
    curveType: 'function',
    lineWidth: 0,
    series: [{ color: '#58e2c2' }, { color: '#1B2342' }, { color: '#7440FB' }],
    intervals: { color: 'series-color' },
    interval: {
      i0: { style: 'area', fillOpacity: 0.5, color: '#58E2C2' },
      i1: { style: 'area', fillOpacity: 0.5, color: '#1b2342' },
      i2: { style: 'area', fillOpacity: 0.5, color: '#7440fb' }
    },
    legend: 'none'
  },
  chartOptionsForLineGraph: {
    backgroundColor: 'transparent',
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out'
    },
    chartArea: {
      left: 40,
      width: '100%'
    },
    tooltip: {
      isHtml: true,
      textStyle: {
        color: '#fff',
        fontSize: 12
      },
      ignoreBounds: true
    },
    colors: ['#58E2C2', '#1B2342', '#7440FB'],
    pointSize: 12,
    fontName: 'Muli',
    fontSize: 14,
    vAxis: {
      baseline: 0,
      viewWindow: { min: 0 },
      baselineColor: 'transparent',
      gridlines: {
        color: 'transparent'
      },
      textStyle: {
        color: '#1B2342'
      },
      minValue: 1
    },
    hAxis: {
      textStyle: {
        color: '#1B2342'
      }
    },
    pointsVisible: true
  },
  chartOptionsForPieChart: {
    backgroundColor: 'transparent',
    animation: {
      startup: true,
      duration: 3000,
      easing: 'in'
    },
    legend: 'none',
    chartArea: {
      width: '90%',
      height: '90%'
    },
    pieStartAngle: 40,
    slices: {
      0: { color: '#1B2342' },
      1: { color: '#58E2C2' }
    },
    pieSliceTextStyle: {
      fontSize: 24
    }
  }
};
